import type { Summary } from 'commonTypes/api/scenarios/BaseTypes';

export const modifySummaries = (summaries: Summary[] = []) => {
  return summaries.map((summary) => ({ label: summary.text, value: summary.value }));
};
